import { render } from "./AuthModalComponent.vue?vue&type=template&id=4e85fc87"
import script from "./AuthModalComponent.vue?vue&type=script&lang=js"
export * from "./AuthModalComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__